// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"d680b42b","245":"765cab23","272":"7e03e11c","362":"4f51bb57","375":"efc937fe","473":"c58c5b16","758":"05e52374","850":"bbb0efd0"}[chunkId] + ".chunk.js";
};